<template>
  <div class="font-sans bg-[#f6f4f1] text-[#1f2937] min-h-screen flex flex-col">
    <!-- 🌟 HEADER -->
    <!-- HEADER -->
    <header class="bg-[#1a1a1a] text-white shadow sticky top-0 z-50">
      <div class="max-w-7xl mx-auto px-4 py-4 flex justify-between items-center">
        <!-- LOGO -->
        <div class="flex items-center gap-2">
          <img src="/logo.png" alt="Logo" class="h-20 w-auto" />
        </div>

        <!-- NAV DESKTOP -->
        <nav class="hidden md:flex items-center gap-8">
          <a href="#sobre" class="hover:text-[#b99a52] transition">Sobre</a>
          <a href="#categorias" class="hover:text-[#b99a52] transition">Categorias</a>
          <a href="#seguranca" class="hover:text-[#b99a52] transition">Segurança</a>
          <a href="#como-funciona" class="hover:text-[#b99a52] transition">Como funciona</a>
        </nav>

        <!-- AÇÕES DESKTOP -->
        <div class="hidden md:flex gap-3">
          <router-link to="/login"
            class="px-4 py-2 rounded-full border border-white/20 bg-white/10 hover:bg-white/20 transition whitespace-nowrap">
            Fazer login
          </router-link>
          <router-link to="/cadastro"
            class="px-4 py-2 rounded-full bg-[#b99a52] hover:bg-[#a18446] text-white transition whitespace-nowrap">
            Cadastrar
          </router-link>
        </div>

        <!-- MENU MOBILE -->
        <button class="md:hidden text-2xl leading-none" @click="showMenu = true" aria-label="Abrir menu">
          ☰
        </button>
      </div>

      <!-- DRAWER MOBILE -->
      <div v-if="showMenu" class="fixed inset-0 bg-black/40 backdrop-blur-sm z-[999] flex md:hidden"
        @click.self="showMenu = false">
        <div class="w-80 max-w-[85vw] bg-white text-[#152a34] h-full p-6 overflow-y-auto shadow-xl animate-slideLeft">
          <div class="flex items-center justify-between mb-4">
            <h2 class="text-lg font-semibold">Menu</h2>
            <button class="text-gray-500 text-xl" @click="showMenu = false" aria-label="Fechar menu">✕</button>
          </div>

          <!-- LINKS -->
          <nav class="space-y-2">
            <a href="#sobre" class="block px-3 py-2 rounded-xl hover:bg-gray-100"
              @click="closeAndScroll('#sobre')">Sobre</a>
            <a href="#categorias" class="block px-3 py-2 rounded-xl hover:bg-gray-100"
              @click="closeAndScroll('#categorias')">Categorias</a>
            <a href="#seguranca" class="block px-3 py-2 rounded-xl hover:bg-gray-100"
              @click="closeAndScroll('#seguranca')">Segurança</a>
            <a href="#como-funciona" class="block px-3 py-2 rounded-xl hover:bg-gray-100"
              @click="closeAndScroll('#como-funciona')">Como funciona</a>
          </nav>

          <div class="my-6 border-t"></div>

          <!-- CTAs -->
          <div class="space-y-3">
            <router-link to="/login"
              class="block w-full text-center px-4 py-3 rounded-xl border border-[#e0dcd6] bg-white hover:bg-gray-50 transition font-semibold"
              @click="showMenu = false">
              Fazer login
            </router-link>

            <router-link to="/cadastro"
              class="block w-full text-center px-4 py-3 rounded-xl bg-[#b99a52] hover:bg-[#a18446] text-white transition font-semibold"
              @click="showMenu = false">
              Cadastrar
            </router-link>
          </div>
        </div>

        <div class="flex-1"></div>
      </div>
    </header>

    <!-- 🟡 HERO -->
    <section class="relative flex-1 flex flex-col justify-center items-center text-center bg-cover bg-center">
      <div class="absolute inset-0 bg-black/60"></div>

      <div class="relative z-10 max-w-3xl px-6 mt-15">
        <h1 class="text-4xl sm:text-5xl font-extrabold text-white mb-4">
          Conectamos <span class="text-[#b99a52]">trabalhadores</span> e
          <span class="text-[#b99a52]">empresas</span>
        </h1>
        <p class="text-white/90 text-lg mb-8">
          Crie propostas, encontre profissionais qualificados e mova sua ideia do papel - tudo em um só lugar.
        </p>
        <div class="flex flex-col sm:flex-row gap-3 justify-center mb-8">
          <router-link to="/projetos"
            class="px-6 py-3 rounded-full bg-[#b99a52] hover:bg-[#a18446] text-white font-semibold transition">
            Encontre Trabalho
          </router-link>
          <router-link to="/buscar-prestadores"
            class="px-6 py-3 rounded-full bg-white hover:bg-gray-200 text-[#152a34] font-semibold transition">
            Encontre Trabalhadores
          </router-link>
        </div>
      </div>
    </section>

    <!-- 💼 SEÇÃO SOBRE -->
    <section id="sobre" class="py-20 bg-[#fff] text-center px-6">
      <h2 class="text-3xl font-bold mb-4 text-[#152a34]">Trabalhar nunca foi tão fácil</h2>
      <p class="text-gray-600 max-w-3xl mx-auto mb-10">
        O GetLance é um marketplace moderno que conecta quem precisa de um serviço a quem sabe fazer.
        Aqui você cria propostas, negocia valores com segurança e garante pagamentos com garantia GetLance.
      </p>

      <div class="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-5xl mx-auto">
        <!-- Card 1 -->
        <div class="bg-[#f6f4f1] rounded-xl p-6 shadow hover:shadow-lg transition">
          <div class="h-12 w-12 mx-auto mb-4 rounded-xl bg-white/70 flex items-center justify-center shadow-sm"
            aria-hidden="true">
            <!-- inline SVG (briefcase) -->
            <svg viewBox="0 0 24 24" class="h-7 w-7 text-[#152a34]" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M10 6a2 2 0 0 1 2-2h0a2 2 0 0 1 2 2v2H10V6Z" />
              <path d="M4 9h16a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2Z" />
              <path d="M8 12v1a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-1" />
            </svg>
          </div>
          <h3 class="text-lg font-semibold mb-2">Crie sua proposta</h3>
          <p class="text-gray-500 text-sm">Publique o que precisa e receba ofertas de profissionais em minutos.</p>
        </div>

        <!-- Card 2 -->
        <div class="bg-[#f6f4f1] rounded-xl p-6 shadow hover:shadow-lg transition">
          <div class="h-12 w-12 mx-auto mb-4 rounded-xl bg-white/70 flex items-center justify-center shadow-sm"
            aria-hidden="true">
            <!-- inline SVG (chat) -->
            <svg viewBox="0 0 24 24" class="h-7 w-7 text-[#152a34]" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M21 12a8 8 0 0 1-8 8H7l-4 3v-5a8 8 0 0 1-1-6 9 9 0 0 1 18 0Z" />
              <path d="M8 12h.01M12 12h.01M16 12h.01" stroke-linecap="round" />
            </svg>
          </div>
          <h3 class="text-lg font-semibold mb-2">Negocie com segurança</h3>
          <p class="text-gray-500 text-sm">Converse diretamente no chat da plataforma antes de fechar o negócio.</p>
        </div>

        <!-- Card 3 -->
        <div class="bg-[#f6f4f1] rounded-xl p-6 shadow hover:shadow-lg transition">
          <div class="h-12 w-12 mx-auto mb-4 rounded-xl bg-white/70 flex items-center justify-center shadow-sm"
            aria-hidden="true">
            <!-- inline SVG (shield/coin) -->
            <svg viewBox="0 0 24 24" class="h-7 w-7 text-[#152a34]" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M12 2l8 4v6c0 5-3.5 9.5-8 10-4.5-.5-8-5-8-10V6l8-4Z" />
              <path d="M9 12h6M10 9h4M10 15h4" stroke-linecap="round" />
            </svg>
          </div>
          <h3 class="text-lg font-semibold mb-2">Pagamento com garantia GetLance</h3>
          <p class="text-gray-500 text-sm">
            O valor fica reservado e é liberado somente após o serviço ser entregue com sucesso.
          </p>
        </div>
      </div>
    </section>

    <!-- 🧭 CATEGORIAS -->
    <section id="categorias" class="bg-[#152a34] text-white py-20 text-center px-6">
      <h2 class="text-3xl font-bold mb-4">Encontre profissionais por categoria</h2>
      <p class="text-white/80 mb-10">Temos centenas de categorias para todo tipo de projeto.</p>

      <div class="flex flex-wrap justify-center gap-4 max-w-4xl mx-auto">
        <span v-for="cat in mockCategories" :key="cat"
          class="px-5 py-2 bg-white/10 rounded-full text-sm hover:bg-[#b99a52] hover:text-white cursor-pointer transition">
          {{ cat }}
        </span>
      </div>
    </section>

    <!-- 🔒 SEGURANÇA -->
    <section id="seguranca" class="py-20 bg-[#f6f4f1] text-center px-6">
      <h2 class="text-3xl font-bold mb-6 text-[#152a34]">Garantia financeira GetLance</h2>
      <p class="text-gray-600 max-w-3xl mx-auto mb-8">
        A GetLance oferece um sistema de garantia que assegura que o prestador receba apenas após o serviço ser
        concluído e aprovado. Transparência e confiança de ponta a ponta.
      </p>
    </section>

    <!-- 🗣️ DEPOIMENTOS (AUMENTADOS) -->
    <section class="bg-[#fff] py-20 text-center px-6">
      <h2 class="text-3xl sm:text-4xl font-bold mb-12 text-[#152a34]">Histórias de sucesso</h2>

      <!-- mais largo + mais espaçamento -->
      <div class="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-7xl mx-auto">
        <div v-for="(testimony, i) in testimonials" :key="i"
          class="bg-[#f6f4f1] rounded-2xl shadow p-8 hover:shadow-xl transition flex flex-col justify-between text-left">
          <!-- quote icon -->
          <div class="flex items-start justify-between gap-4 mb-6">
            <div class="flex items-center gap-2">
              <span class="inline-flex h-10 w-10 rounded-xl bg-white/70 items-center justify-center shadow-sm"
                aria-hidden="true">
                <svg viewBox="0 0 24 24" class="h-6 w-6 text-[#b99a52]" fill="none" stroke="currentColor"
                  stroke-width="2">
                  <path d="M10 11H6a4 4 0 0 0 0 8h2v-6h2v-2Zm8 0h-4a4 4 0 0 0 0 8h2v-6h2v-2Z" />
                </svg>
              </span>
              <p class="text-sm font-semibold text-[#152a34]">Depoimento</p>
            </div>

            <!-- stars -->
            <div class="flex gap-1" aria-label="Avaliação 5 estrelas">
              <svg v-for="s in 5" :key="s" viewBox="0 0 24 24" class="h-4 w-4 text-[#b99a52]" fill="currentColor">
                <path
                  d="M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27Z" />
              </svg>
            </div>
          </div>

          <!-- texto maior -->
          <p class="text-gray-700 text-base leading-relaxed mb-8 italic">
            “{{ testimony.text }}”
          </p>

          <div class="flex items-center gap-4 pt-6 border-t border-black/5">
            <!-- avatar inline (sem imagem) -->
            <div class="h-12 w-12 rounded-full bg-white/80 shadow-sm flex items-center justify-center"
              aria-hidden="true">
              <svg viewBox="0 0 24 24" class="h-7 w-7 text-[#152a34]" fill="none" stroke="currentColor"
                stroke-width="2">
                <path d="M20 21a8 8 0 0 0-16 0" />
                <path d="M12 11a4 4 0 1 0-4-4 4 4 0 0 0 4 4Z" />
              </svg>
            </div>

            <div>
              <p class="font-semibold text-lg text-[#152a34] leading-tight">{{ testimony.name }}</p>
              <p class="text-sm text-gray-500">{{ testimony.role }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ⚙️ COMO FUNCIONA -->
    <section id="como-funciona" class="bg-white py-20 text-center px-6">
      <h2 class="text-3xl font-bold mb-10 text-[#152a34]">Como funciona?</h2>
      <div class="max-w-5xl mx-auto grid grid-cols-1 sm:grid-cols-3 gap-8">
        <div class="flex flex-col items-center">
          <div
            class="bg-[#b99a52] text-white rounded-full w-16 h-16 flex items-center justify-center text-2xl font-bold mb-4">
            1
          </div>
          <h3 class="font-semibold text-lg mb-2">Crie sua conta</h3>
          <p class="text-gray-500 text-sm">Leva menos de um minuto para começar a usar a plataforma.</p>
        </div>

        <div class="flex flex-col items-center">
          <div
            class="bg-[#b99a52] text-white rounded-full w-16 h-16 flex items-center justify-center text-2xl font-bold mb-4">
            2
          </div>
          <h3 class="font-semibold text-lg mb-2">Publique ou procure um trabalho</h3>
          <p class="text-gray-500 text-sm">Crie um anúncio ou busque projetos de acordo com suas habilidades.</p>
        </div>

        <div class="flex flex-col items-center">
          <div
            class="bg-[#b99a52] text-white rounded-full w-16 h-16 flex items-center justify-center text-2xl font-bold mb-4">
            3
          </div>
          <h3 class="font-semibold text-lg mb-2">Finalize e receba</h3>
          <p class="text-gray-500 text-sm">Conclua o trabalho, receba o pagamento e construa sua reputação.</p>
        </div>
      </div>
    </section>

    <!-- 🚀 CTA FINAL -->
    <section class="bg-[#b99a52] text-white text-center py-16">
      <h2 class="text-3xl font-bold mb-3">Pronto para começar?</h2>
      <p class="mb-6">Crie sua conta gratuita e comece a trabalhar hoje mesmo.</p>
      <router-link to="/cadastro"
        class="bg-white text-[#152a34] px-8 py-3 rounded-full font-semibold hover:bg-gray-100 transition">
        Criar minha conta
      </router-link>
    </section>

    <AppFooter />
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import AppFooter from "@/components/AppFooter.vue";

const router = useRouter();
const showMenu = ref(false);

onMounted(() => {
  const userData = localStorage.getItem("userData");
  if (userData) {
    router.replace("/projetos");
  }
});

function closeAndScroll(hash) {
  showMenu.value = false;

  setTimeout(() => {
    const el = document.querySelector(hash);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    else window.location.hash = hash;
  }, 50);
}

const mockCategories = [
  "Reformas e Construção",
  "Design Gráfico",
  "Programação",
  "Serviços Domésticos",
  "Beleza e Estética",
  "Manutenção e Reparos",
  "Transporte e Fretes",
  "Eventos e Festas",
  "Consultoria",
];

const testimonials = [
  {
    name: "Lucas Almeida",
    role: "Designer Freelancer",
    text: "Consegui meus primeiros clientes em menos de uma semana usando o GetLance!",
    avatar: "/avatar-1.jpg",
  },
  {
    name: "Mariana Souza",
    role: "Empresária",
    text: "Contratar profissionais se tornou muito mais fácil e seguro. A plataforma é incrível!",
    avatar: "/avatar-2.jpg",
  },
  {
    name: "Carlos Mendes",
    role: "UX Design",
    text: "Recebo projetos e o pagamento sempre cai direitinho. Recomendo demais!",
    avatar: "/avatar-3.jpg",
  },
];
</script>